import { useTranslation } from "react-i18next"
import { colors, css, fonts, glyphs, icons } from "../../../Styles"
import { ButtonList, Widget } from "../..";
import { ListStyle_Types } from "../../../Definitions";
import { useState } from "react";
// TODO MAJA: Toggle btn text from "start" to "stop" when system is (not) running: t("locationFeeder.overView.systemOff")

/**
 * SystemControls
 * @returns A widget with btns to controle the system.
 */
export default function SystemControls() {
  const {t} = useTranslation(); 
  const [isOn, setIsOn] = useState<boolean>(false)
  const [isRunning, setIsRunning] = useState<boolean>(false)
  // const [isCalibrating, setIsCalibrating] = useState<boolean>(false)
  // const [isEmptying, setIsEmptying] = useState<boolean>(false)
  const [systemState, setSystemState] = useState<"running" | "paused" | "calibrating" | "emptying">("paused");


  const systemPower = isOn
  ? {
      systemPower: t("locationFeeder.overView.systemOn"),
      statusColor: colors.systemGreen,
      buttonText: t("locationFeeder.overView.systemOff"),
      buttonEnhancer: glyphs.OnOff({ size: "30px", rotate: 90 }),
    }
  : {
      systemPower: t("locationFeeder.overView.systemOff"),
      statusColor: colors.systemRed,
      buttonText: t("locationFeeder.overView.systemOn"),
      buttonEnhancer: glyphs.OnOff({ size: "30px"}),
    };

  const systemStateConfig = {
    running: {
      systemState: t("locationFeeder.overView.systemStateRunning"),
      statusColor: colors.systemGreen,
      textColor: colors.greyLightTertiary
    },
    paused: {
      systemState: t("locationFeeder.overView.systemStatePaused"),
      statusColor: colors.systemRed,
      textColor: colors.greyLightTertiary
    },
    calibrating: {
      systemState: t("locationFeeder.overView.systemStateCalibrating"),
      statusColor: colors.systemYellow,
      textColor: colors.greyDarkPrimary
    },
    emptying: {
      systemState: t("locationFeeder.overView.systemStateEmptying"),
      statusColor: colors.systemYellow,
      textColor: colors.greyDarkPrimary
    }
  }

  const currentSystemState = systemStateConfig[systemState];

  return(
    <Widget
      header={<p style={{...fonts.header, ...fonts.fontSize3, color: colors.greyLightTertiary}}>{t("locationFeeder.overView.systemControls")}</p>}
      bgColor={colors.greyPrimary}
      width="300px"
      height="350px"
      content={
        <div style={{display: "flex", flexDirection: "column", gap: "10px", justifyContent: "space-between", marginBottom: "20px"}}>
          <div style={{height: "55px", display: "flex", flexDirection: "column", justifyContent: "space-between"}}>
            <div style={{display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", width: "270px", alignItems: "center"}}>
              <p style={{...fonts.fontSize4, ...fonts.paragraph, color: colors.greyLightTertiary, textAlign: "end", gridArea: "1/1/2/2"}}>Power: </p>
              <div style={{...fonts.fontSize4, ...fonts.header, backgroundColor: systemPower.statusColor, color: colors.greyLightTertiary, padding: "4px 5px", borderRadius: "6px", textAlign: "start", gridArea: "1/2/2/3", width: "fit-content"}}>{ systemPower.systemPower }</div>
            </div>
            {isOn?
            <div style={{display: "grid", gridTemplateColumns: "1fr 1fr", gap: "10px", width: "270px", alignItems: "center"}}>
              <p style={{...fonts.fontSize4, ...fonts.paragraph, color: colors.greyLightTertiary, textAlign: "end", gridArea: "1/1/2/2"}}>System Status: </p>
              <div style={{...fonts.fontSize4, ...fonts.header, backgroundColor: currentSystemState.statusColor, color: currentSystemState.textColor, padding: "4px 5px", borderRadius: "6px", textAlign: "start", gridArea: "1/2/2/3", width: "fit-content"}}>
                {currentSystemState.systemState}
              </div>
            </div> : <></> }
          </div>
          <ButtonList
            contents={[
              isRunning? t("locationFeeder.overView.stop") : t("locationFeeder.overView.start"),
              t("locationFeeder.overView.calibrate"),
              systemPower.buttonText,
              t("locationFeeder.overView.emptySystem"),
            ]}
            startEnhancers={[
              isRunning? glyphs.Stop({size: "30px"}) : glyphs.Start({size: "30px"}),
              glyphs.Calibrate({ size: "30px" }),
              systemPower.buttonEnhancer,
              glyphs.Empty({ size: "30px" }),
            ]}
            overrides={{
              baseButton: {backgroundColor: colors.greySecondary},
              hoverStyles: {backgroundColor: colors.greyDarkSecondary},
              startEnhancerStyles: {...css.button_PositionStartEnhancerStart},
              disabledStyles: {opacity: "0.3"}
            }}
            listOverrides={{
              listStyle: ListStyle_Types.vertical
            }}
            disabled={[isOn? false : true, isOn? false : true, false, isOn? false : true, ]}
            onClick={(i) => {
              if (i === 0) {
                setIsRunning(!isRunning);  // Skift status for isRunning
                setSystemState(isRunning ? "paused" : "running");  // Skift system state
              }
              if (i === 1) {setSystemState("calibrating"); setIsRunning(false)}
              if (i === 2) {
                setIsOn(!isOn);
                if (!isOn) setSystemState("paused");
              }
              if (i === 3) {setSystemState("emptying"); setIsRunning(false)}
            }}
          />
        </div>
      }
    />
  )
}